export const recognizedFood = {
  name: "西红柿炒蛋盖浇饭",
  estimatedWeight: 380,
  confidence: 92,
  image: "https://readdy.ai/api/search-image?query=Top-down%20view%20of%20a%20Chinese%20home-style%20dish%20of%20scrambled%20eggs%20with%20tomato%20served%20over%20white%20rice%20in%20a%20simple%20ceramic%20bowl%2C%20warm%20kitchen%20lighting%2C%20steam%20rising%20slightly%2C%20clean%20minimalist%20food%20photography%2C%20appetizing%20and%20warm%20color%20tones&width=960&height=960&seq=recognize-food-1&orientation=squarish",
  nutrition: {
    calories: 420,
    protein: 14,
    carbs: 58,
    fat: 12,
    fiber: 3.2,
    vitC: 28,
  },
  aiAdvice: "蛋白质偏低，建议加一个鸡蛋或搭配一份豆腐，提升营养平衡。",
  alternative: [
    { name: "蛋炒饭", weight: 350, calories: 460, protein: 10, carbs: 68, fat: 16 },
    { name: "番茄牛腩饭", weight: 400, calories: 520, protein: 24, carbs: 52, fat: 20 },
    { name: "素炒米饭", weight: 320, calories: 340, protein: 6, carbs: 62, fat: 8 },
  ],
};

export const targets = {
  calories: 2000,
  protein: 60,
  carbs: 260,
  fat: 70,
  fiber: 30,
  vitC: 100,
};